<template>
<div class="chapter">
<div class="inner_page">
<h2 class="partnum" id="Part_One"><span epub:type="pagebreak" id="page1" title="1">PART ONE</span></h2>
<p class="parttitle">THE FRENCH WAR—THE IDEA, AND BULLETS</p>
<p class="indentpart">***</p>
<p class="indentpart">General Vo Nguyen Giap:</p>
<p class="indentpart1"><em class="italic">“C’est fini. It’s over. We will yield no longer.”</em></p>
<p class="indentpart">Hanoi, December 18, 1946</p>
<p class="indentpartd">***</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Part_One.vue?33a6c654